import { BASE_STATIC_URL } from '../../config'
import Audio from '../../components/atom/Audio'
import { h } from '../parser/utils'

import { UPLOADS_PREFIX } from './links'

export const NAME = 'audio'

export const COMPONENTS = {
  Audio,
}

export function matches(node, ctx) {
  return node.nodeType === ctx.window.Node.TEXT_NODE &&
    node.textContent &&
    node.textContent.indexOf('[audio') !== -1
}

const AUDIO_REGEX = /(\[audio:.*\])/g

const AUDIO_BASE_URL = `${BASE_STATIC_URL}${UPLOADS_PREFIX}audio`
const SHORT_CODE_PREFIX = '[audio:'

export const transform = (node) => {
  const text = node.textContent || ''

  const parts = text.split(AUDIO_REGEX)

  return parts
    .filter(entry => entry.trim())
    .map((text) => {
      if (text.indexOf(SHORT_CODE_PREFIX) === -1) {
        return text
      }

      return h(Audio, {
        controls: true,
        src: `${AUDIO_BASE_URL}/${text.substring(SHORT_CODE_PREFIX.length, text.length - 1)}`,
      })
    })
}
